import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { OutLinedButton } from '@/Components/Buttons/OutLinedButton';
import { red } from '@mui/material/colors';

export const SectionHeader = ({ 
  title, 
  buttons = [],                // Buttons on the right side (already handled)
  titleButtons = [],           // 🆕 Optional buttons near the title
  titleColor = "var(--createheading-0)",
  divider = true
}) => {
  return (
    <>
      <Box sx={{ px: 2, py: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
            variant='subheadingBold'
              sx={{
                color: titleColor,
                mb: 1,
                mt: 1,
              }}
            >
              {title}
            </Typography>

            {/* Render buttons next to title if any */}
            {titleButtons.length > 0 && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {titleButtons.map((button, index) => (
                  <OutLinedButton
                  variant="bodyMedium"
                  key={`main-button-${index}`}
                  label={button.label}
                  startIcon={button.icon}
                  onClick={button.onClick}
                  sx={{
                    width: "auto",
                    color:"var(--brand-600)",
                    minWidth: "100px",
                    border: "none !important",
                    borderColor: "transparent !important",
                    boxShadow: "none !important",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "var(--gray-0)",
                      border: "none !important",
                    },
                  }}
                />
                ))}
              </Box>
            )}
          </Box>

          {/* === Right Side Buttons === */}
          {buttons.length > 0 && (
            <Box sx={{ display: "flex", alignItems: "center",gap:1 }}>
              {buttons.map((button, index) => (
                <OutLinedButton
                variant={"bodyMedium"}
                  key={`main-button-${index}`}
                  label={button.label}
                  startIcon={button.icon}
                  onClick={button.onClick}
                  disabled={button.disabled}
                  sx={{
                    ...{
                      color:"var(--brand-600)",
                      height: 40,
                      width: "auto",
                      textTransform: "none",
                      border: "none !important",
                      borderColor: "transparent !important",
                      boxShadow: "none !important",
                      "&:hover": {
                        backgroundColor: "var(--gray-0)",
                        border: "none !important",
                      },
                    },
                    ...button.sx, // ensure this is last for override
                  }}
                  
                />
              ))}
            </Box>
          )}
        </Box>
      </Box>

      {divider && <Divider />}
    </>
  );
};